import { Heading } from '@cinch-labs/design-system'
import styles from './related-reviews.module.css'
import { FormattedRelatedStoryContent } from '../../types/car-review-page'
import sharedStyles from '../../car-reviews-v2.module.css'
import { StarRating } from '../star-rating'
import {
  EventNames,
  TrackingEventTypes,
  useAnalytics,
} from '@cinch-nx/shared-analytics'

export interface RelatedReviewsProps {
  items: FormattedRelatedStoryContent[]
  make: string
  model: string
}

export const formattedHref = (url: string) =>
  url.replace(/car-reviews-v2/g, '/used-cars')

export const RelatedReviews: React.FC<RelatedReviewsProps> = ({
  items,
  make,
  model,
}) => {
  const { trackEvent } = useAnalytics()
  const handleClick = (
    currentMake: string,
    currentModel: string,
    suggestedVehicleReview: string,
  ) => {
    const suggestedMakeAndModel = suggestedVehicleReview
      .replace(/\w+[!.?]?$/, '')
      .toLocaleLowerCase()
    trackEvent({
      eventName: `similar reviews - from ${make} ${model}`,
      type: TrackingEventTypes.ADOBE,
      data: {
        event: {
          name: EventNames.click,
          category: 'similar reviews',
          label: `from ${currentMake} ${currentModel}`,
          action: `to ${suggestedMakeAndModel}`,
        },
      },
    })
  }

  return (
    <section className={sharedStyles.inner}>
      <Heading element={'h2'} fontSize={'h3'}>
        Similar to the{' '}
        <span className={styles.capitalise}>
          {make} {model}
        </span>
        <span> review</span>
      </Heading>
      <div>
        {items.map((item, index) => (
          <div
            className={styles.relatedItem}
            key={index}
            onClick={() =>
              window.location.assign(formattedHref(item.full_slug))
            }
          >
            <div className={styles.relatedImgWrapper}>
              <div className={styles.relatedImgBorder}>
                <img
                  className={styles.relatedImg}
                  alt={`${make} ${model}`}
                  src={
                    item.image ||
                    `${
                      process.env['STAGE_NAME'] === 'local'
                        ? ''
                        : process.env.STAGE_URL
                    }/image-coming-soon.svg`
                  }
                />
              </div>
            </div>
            <div className={styles.relatedContentWrapper}>
              <Heading element={'h3'} className={styles.relatedTitle}>
                {item.title}
              </Heading>

              <div className={styles.relatedStars}>
                <StarRating starRating={Number(item.starRating)} />
              </div>

              <p className={styles.relatedSnippet}>{item.snippet}</p>
              <a
                href={formattedHref(item.full_slug)}
                className={styles.relatedLink}
                onClick={() => handleClick(make, model, item.title)}
              >
                Read more
              </a>
            </div>
          </div>
        ))}
      </div>
    </section>
  )
}
